import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { superadminAuthInterceptor } from './auth/auth.interceptor';
import { apiToastInterceptor } from '../../../../libs/core';
import { zonelessChangeDetectionInterceptor } from './zoneless-change-detection.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch(), withInterceptors([superadminAuthInterceptor, apiToastInterceptor, zonelessChangeDetectionInterceptor])),
    provideRouter(appRoutes),
  ],
};
